import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HttpClientModule } from '@angular/common/http';
import { graphqlProvider } from './graphql.provider';
import { Apollo } from 'apollo-angular';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { NgxSummernoteModule } from 'ngx-summernote';
import { TokenInjectorInterceptorProvider } from './core/interceptors/http.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    importProvidersFrom(HttpClientModule),
    TokenInjectorInterceptorProvider,
    graphqlProvider,
    Apollo,
    ConfirmationService,
    MessageService,
    DynamicDialogConfig,
    DynamicDialogRef,
    NgxSummernoteModule,
    DialogService
  ],
};
